<template lang="pug">
component.base-button(:href="href", :is="tag", :type="tag === 'a' ? undefined : type", :class="[dimension, size, color, disabled ? '' : 'cursor-pointer']", :disabled="disabled", target="_blank", @click="onClick")
  slot
</template>
<script setup>
const emit = defineEmits(['click'])
const { tag, href, type, color, disabled, dimension } = defineProps({
  tag: {
    type: String,
    default: 'button',
  },
  type: {
    type: String,
    default: 'button',
  },
  color: {
    type: String,
    validator(value) {
      return ['confirm', 'notice', 'default', 'diamond'].includes(value)
    },
    default() {
      return 'confirm'
    },
  },
  size: {
    type: String,
    validator(value) {
      return ['sm', 'md', 'lg'].includes(value)
    },
    default() {
      return 'sm'
    },
  },
  disabled: {
    type: Boolean,
    default() {
      return false
    },
  },
  href: {
    type: String,
  },
  dimension: {
    type: String,
    default() {
      return ''
    },
  },
})

const onClick = (event) => {
  emit('click', event)
}
</script>
<style lang="scss" scoped>
.base-button {
  background-color: transparent;
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size:
    1.5rem 100%,
    1.5rem 100%,
    calc(100% - 3rem + 2px) 100%;
  background-position:
    left,
    right,
    left calc(1.5rem - 1px) top 0px;
  font-weight: 500;
}

.confirm {
  background-image:
    url('assets/images/common/btn_img_confirm_normal_left.png'), url('assets/images/common/btn_img_confirm_normal_right.png'),
    url('assets/images/common/btn_img_confirm_normal_middle.png');
}

.notice {
  background-image:
    url('assets/images/common/btn_img_notice_normal_left.png'), url('assets/images/common/btn_img_notice_normal_right.png'),
    url('assets/images/common/btn_img_notice_normal_middle.png');
}

.default {
  background-image:
    url('assets/images/common/btn_img_default_normal_left.png'), url('assets/images/common/btn_img_default_normal_right.png'),
    url('assets/images/common/btn_img_default_normal_middle.png');
}

.diamond {
  background-image:
    url('assets/images/common/btn_img_diamond_normal_left.png'), url('assets/images/common/btn_img_diamond_normal_right.png'),
    url('assets/images/common/btn_img_diamond_normal_middle.png');
}

.base-button:disabled {
  background-image:
    url('assets/images/common/btn_img_disable_normal_left.png'), url('assets/images/common/btn_img_disable_normal_right.png'),
    url('assets/images/common/btn_img_disable_normal_middle.png');
}
</style>
